// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__V06ks","previousIcon":"Modal_previousIcon__pIwUE","closeIcon":"Modal_closeIcon__4ORcF"};